<template>
   <section class="index">
          <div class="main">
            <!--maintitle-->
            <div class="maintitle noneform">
              <h1><img src="../../asset/svg/title/maintitle_desktop.svg" alt="生命有多麽地差異，世界有多麽地美麗">
                <div class="circleborder"></div>
              </h1>
              <p class="graycolor">用堅定的力量，與孩子共同學習成長</p>
            </div>
            <!--indexmenu-->
            <div class="formenu">
              <div class="indexmenu">
                <!--bluebg-->
                <ul class="bluebg">
                  <li><a><img src="../../img/index_menu/blue/1.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/2.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/3.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/4.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/5.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/6.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/7.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/8.png"></a></li>
                  <li><a><img src="../../img/index_menu/blue/9.png"></a></li>
                </ul>
                <!--realmenu-->
                <ul class="realmenu">
                  <!--aboutlink-->
                  <li class="mm" data-menu="m_01"><a href="javascript:void(0)" v-on:click="go('about')"><img src="../../img/index_menu/1.png"></a></li>
                  <li class="mm" data-menu="m_06"><a href="javascript:void(0)" v-on:click="go('product')"><img src="../../img/index_menu/2.png"></a></li>
                  
                  <li><a><img src="../../img/index_menu/3.png"></a></li>
                  <!--contactlink-->
                  <li class="mm" data-menu="m_02"><a href="javascript:void(0)" v-on:click="go('artist')"><img src="../../img/index_menu/4.png"></a></li>
                  <!--startlink-->
                  <li class="mm" data-menu="m_03"><a href="javascript:void(0)" v-on:click="go('start')"><img src="../../img/index_menu/5.png"></a></li>
                  <!--supportlink-->
                  <li class="mm" data-menu="m_04"><a href="javascript:void(0)" v-on:click="go('support')"><img src="../../img/index_menu/6.png"></a></li>
                  <li><a><img src="../../img/index_menu/7.png"></a></li>
                  <li><a><img src="../../img/index_menu/8.png"></a></li>
                  <!--artistlink-->
                  <li class="mm" data-menu="m_05"><a href="javascript:void(0)" v-on:click="go('contact')"><img src="../../img/index_menu/9.png"></a></li>
                </ul>
                <!--menutxt-->
                <!--aboutlink-->
                <p class="menutxt" id="m_01"><img src="../../asset/svg/bookmark/about.svg"></p>
                <!--artistlink-->
                <p class="menutxt" id="m_02"><img src="../../asset/svg/bookmark/artist.svg"></p>
                <!--startlink-->
                <p class="menutxt" id="m_03"><img src="../../asset/svg/bookmark/start.svg"></p>
                <!--supportlink-->
                <p class="menutxt" id="m_04"><img src="../../asset/svg/bookmark/support.svg"></p>
                <!--contactlink-->
                <p class="menutxt" id="m_05"><img src="../../asset/svg/bookmark/contact.svg"></p>
                <p class="menutxt" id="m_06"><img src="../../asset/svg/bookmark/product.svg"></p>

              </div>
            </div>
            <!--maintitle-->
            <div class="maintitle nonefordesktop">
              <h1><img src="../../asset/svg/title/maintitle_m.svg" alt="生命有多麽地差異，世界有多麽地美麗"></h1>
              <p class="graycolor">用堅定的力量，與孩子共同學習成長</p>
            </div>
            <div class="clear"></div>
          </div>
          <!--scroll--><a href="javascript:void(0)" class="scroll" v-on:click="goAbout()">
            <p>scroll</p></a>
        </section>


</template>

<script>
    // import navBar from './common/Nav.vue'
    export default {
        mounted:function(){
          var $this=this;
          console.log('kv mounted')
          $('.main').css({opacity:1});

          $( ".realmenu li" ).hover(
            function() {
              if($(this).hasClass('mm')){ 
                $(".menutxt").removeClass('hide');
                var ele=$(this).attr('data-menu');
                $('#'+ele).addClass('show');
              }
            }, function() {
              $(".menutxt[class*='show']").removeClass('show').addClass('hide');
            }
          );
          $this.kvWidth();
          $(window).resize(function(){
            $this.kvWidth();
          })
            
        },
        methods: {
           go:function(where){
            var $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
            $body.animate({scrollTop:$('section.'+where).offset().top },1000,'easeInQuart');
            gaclick('btn_'+where);
           },
           goAbout:function(){
            var $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
            $body.animate({scrollTop:$('section.about').offset().top },800,'easeInQuart');
            gaclick('btn_about');
          },
          kvWidth:function(){
            // console.log('get height');
            var windowW =$(window).innerHeight()-85;
            $('section.index').css({minHeight:windowW});
          }
        }
    }
</script>


// WEBPACK FOOTER //
// Kv.vue?0e3dcd60